<div class="relative bg-cover bg-center text-white flex justify-center">
  <div class="absolute inset-0"></div>

  <div
    class="relative z-10 flex justify-center w-[54.1875rem] !max-h-[70vh] bg-[#F1F3F5] pb-[1.9375rem] mt-[20px]"
  >
    <div class="flex flex-col items-center">
      <h1
        class="text-[#343A40] login-welcome text-[48px] font-bold leading-[57.6px] pt-[31px]"
      >
        Welcome
      </h1>
      <h4
        class="text-[#21252A] login-text text-center text-[24px] font-semibold leading-[28.8px] tracking-[-0.72px]"
      >
        Enter your credential to access your account
      </h4>
      <div
        class="relative z-10 flex justify-left w-[39rem] !max-h-[63.1vh] pl-[5.87rem]  rounded-[8px] pb-[1.9375rem]"
      >
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <div class="w-[100%] mt-[20px]">
            <div class="flex items-center justify-between w-[503px]">
              <div class="relative w-[26.8125rem]">
                <!-- Material Form Field -->
                <mat-form-field class="w-full" appearance="outline">
                  <mat-label>Email</mat-label>
                  <mat-icon matPrefix class="text-[#FF6F00]">email</mat-icon>
                  <!-- Input Field -->
                  <input
                    matInput
                    id="email"
                    formControlName="email"
                    type="email"
                    placeholder="Enter Your Email"
                    class="bg-[#F1F3F5] text-[#21252A] pl-2 w-full border-none"
                  />
                  <!-- Error Messages -->
                  <mat-error *ngIf="form.get('email')?.errors?.['required']">
                    Email is required
                  </mat-error>
                  <mat-error *ngIf="form.get('email')?.errors?.['email']">
                    Invalid email format
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <!-- Error message for email -->

            <div class="flex items-center justify-between w-[503px] mt-[10px]">
              <div class="relative w-[26.8125rem]">
                <!-- Material Form Field -->
                <mat-form-field class="w-full" appearance="outline">
                  <mat-label>Password</mat-label>
                  <mat-icon matPrefix class="text-[#FF6F00]">lock</mat-icon>
                  <!-- Input Field -->
                  <input
                    matInput
                    id="password"
                    formControlName="password"
                    [type]="viewPassword ? 'text' : 'password'"
                    placeholder="Enter Your Password"
                    class="bg-[#F1F3F5] text-[#21252A]"
                  />
                  <mat-icon
                    matSuffix
                    class="text-[#FF6F00] !text-[20px]"
                    (click)="viewPassword = !viewPassword"
                    >{{
                      viewPassword ? "visibility" : "visibility_off"
                    }}</mat-icon
                  >
                  <!-- Error Messages -->
                  <mat-error *ngIf="form.get('password')?.errors?.['required']">
                    Password is required
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="flex items-center justify-between w-[503px] mt-[10px]">
              <div class="w-[377px]">
                <div class="flex items-center">
                  <input
                    type="checkbox"
                    class="customized-checkbox"
                  />
                  <span
                    class="text-[#21252A] leading-[1.05rem] tracking-[-0.02625rem] !mt-[4px] !text-[0.875rem] Roboto !font-medium"
                    >Remember me</span
                  >
                </div>
              </div>
            </div>
            <div class="flex items-center justify-between w-[503px] mt-[15px]">
              <div class="w-[377px]">
                <!-- (click)="navigateToDashbaord()" -->
                <button
                  type="submit"
                  class="flex w-[130px] h-[48px] p-[14px] px-[39px] justify-center items-center gap-[10px] !font-medium rounded-[0.3125rem] bg-[#E76B3F] hover:E76B3F"
                >
                  Log In
                </button>
              </div>
            </div>

            <div class="flex items-center justify-between w-[503px] mt-[30px]">
              <div class=" grid grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-8">
                <div
                  class="text-[#343A40] text-[0.875rem] font-medium cursor-pointer !mr-[84px]"
                  (click)="navigateToRecoverAccount()"
                >
                  Forgot password?
                </div>
                <div
                  class="text-[#2368A2] text-[1rem] !pl-[20px] !font-medium text-center cursor-pointer"
                  (click)="register()"
                >
                  Register Organization
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
